import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CreateReceiptRequest {
  supplierId?: string | number;
  poId?: string | number;
  companyId: number | string;
  attachmentIds?: number[];
}

interface CreateReceiptResponse {
  poId: number;
  receiptId: number;
  receiptStatus: string;
  receiptStatusDate: string;
  receiptDate: string;
}

const useCreateReceiptApi = () => {
  const call = useCallback(
    (req?: CreateReceiptRequest) =>
      new Promise<CreateReceiptResponse>((resolve, reject) => {
        axiosInstance
          .post<CreateReceiptResponse>(`/receipt`, req)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(new Error(error));
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    createReceipt: execute,
    isCreateReceiptLoading: isLoading,
  };
};

export default useCreateReceiptApi;
